import { Button, Stack, styled } from "@mui/material";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";
import {
  AutoCompleteComponent,
  SelectFieldComponent,
  TextFieldComponent,
} from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import Site from "../../models/Site";
import { RoleOptionsNoAll, RoleOptionsUserAll } from "../../utils/enums/EnsolversStaffRoles";
import { SitesPriority } from "../../utils/enums/SitesPriority";
import { SpinnerWrapper } from "../SpinnerWrapper";
import OpsDialogImage from "../OpsDialogImage";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import RoleUtils from "../../utils/RoleUtils";
import { useStyles } from "../Main/formStyles";
import { Token } from "../../theme";

interface Props {
  isLoading: boolean;
  projects: AutoCompleteUIDTO[];
  handleUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleImageDelete: () => void;
  onClose: () => void;
  handleOnUpdate: (instance: Site) => void;
  open: boolean;
  selectedFile: string | undefined;
  editSite: Site | undefined;
}

interface SelectOption {
  value: string;
  label: string;
}

export default function SiteEditDialog(props: Props) {
  const customStyles = useStyles();

  const currentImage = (): string => {
    return props.selectedFile != undefined ? props.selectedFile : props.editSite?.imageUrl!;
  };
  const getProjectOptions = () => {
    let projectOptions: SelectOption[] = [];
    RoleUtils.isAdmin() && projectOptions.push({ label: "All", value: "All" });
    props.projects.map((p) => {
      let option: SelectOption = {
        value: p.externalId,
        label: p.label,
      };
      projectOptions.push(option);
    });
    return projectOptions;
  };

  if (!props.editSite) {
    return null;
  }

  return (
    <>
      {props.open ? (
        <GenericForm<Site>
          headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
          buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
          cancelButtonStyles={{
            color: Token.textSecondary,
            border: `1px solid ${Token.borderDefault}`,
            marginBottom: 10,
          }}
          dialogStyles={customStyles.root}
          dialog={true}
          open={!!props.open}
          title={"Edit Site"}
          disableMultipleSubmit
          instance={props.editSite}
          onSave={(instance) => {
            instance.imageUrl = currentImage();
            setTimeout(() => {
              props.onClose();
            }, 500);
            props.handleOnUpdate(instance);
          }}
          onCancel={() => props.onClose()}
          dialogCustomSubmitMessage={"Update"}
          renderContent={(register, errors, control) => (
            <>
              <SpinnerWrapper isLoading={props.isLoading}>
                <OpsDialogImage
                  viewMode={false}
                  selectedFile={props.selectedFile != undefined ? props.selectedFile : props.editSite?.imageUrl}
                  onDelete={() => props.handleImageDelete()}
                />
                <Stack style={{ marginBottom: 10 }} direction="row">
                  <label htmlFor="contained-button-file">
                    <Input
                      id="contained-button-file"
                      type="file"
                      accept=".jpeg, .jpg, .png, .gif, .bmp"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.handleUploadImage(e)}
                    />
                    <SpinnerWrapper isLoading={props.isLoading}>
                      <Button startIcon={<FileUploadIcon />} variant="contained" component="span" sx={{ margin: ".7em" }}>
                        Choose Image
                      </Button>
                    </SpinnerWrapper>
                  </label>
                </Stack>
                <SelectFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  options={Object.entries(RoleOptionsUserAll).map(([value, label]) => ({
                    label,
                    value,
                  }))}
                  propertyName={"roleName"}
                  label={"Roles"}
                  required={true}
                />

                <SelectFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"projectExternalId"}
                  label="Project name"
                  required={true}
                  //editWithPreviousValue={true}
                  options={getProjectOptions()}
                />

                {/* Project selector*/}

                {/* <AutoCompleteComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={'projectExternalId'}
                  label="Projects name"
                  required={true}
                  //editWithPreviousValue={true}
                  options={RoleUtils.isAdmin() ? [{ label: 'All', externalId: 'All' }, ...props.projects] : props.projects}
                /> */}

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"title"}
                  label="Title"
                  required={true}
                />

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"description"}
                  label="Description"
                  required={true}
                  internalProps={{ multiline: true, rows: 6 }}
                  size="small"
                />

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"link"}
                  label="Link"
                  required={true}
                />

                <SelectFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"priority"}
                  label="Priority"
                  required={true}
                  options={Object.entries(SitesPriority).map(([value, label]) => ({
                    label,
                    value,
                  }))}
                />
              </SpinnerWrapper>
            </>
          )}
        />
      ) : null}
    </>
  );
}

const Input = styled("input")({
  display: "none",
});
